// src/services/utils/authUtils.js
// Auth store integration utilities (imports store for state management)

import useAuthStore from "../../stores/authStore";
import {
  getRefreshTokenCookie,
  setRefreshTokenCookie,
  clearRefreshTokenCookie,
} from "./tokenUtils";

// Token management functions that interact with the auth store
export const getAccessToken = () => {
  return useAuthStore.getState().accessToken;
};

export const setAccessToken = (token) => {
  useAuthStore.getState().setAccessToken(token);
};

export const getRefreshToken = () => {
  // First try to get from cookie (more secure)
  const cookieToken = getRefreshTokenCookie();
  if (cookieToken) {
    return cookieToken;
  }

  // Fallback to Zustand store (for backward compatibility)
  return useAuthStore.getState().refreshToken;
};

export const setRefreshToken = (token) => {
  // Store in both cookie (primary) and Zustand store (backup)
  setRefreshTokenCookie(token);
  useAuthStore.getState().setRefreshToken(token);
};

export const clearTokens = () => {
  // Clear both cookie and Zustand store
  clearRefreshTokenCookie();
  useAuthStore.getState().clearAuth();
};

// Re-export pure utility functions for backward compatibility
export {
  parseJwt,
  setRefreshTokenCookie,
  getRefreshTokenCookie,
  clearRefreshTokenCookie,
} from "./tokenUtils";
